import { render, staticRenderFns } from "./SetMedia.vue?vue&type=template&id=3dab451c&scoped=true"
import script from "./SetMedia.vue?vue&type=script&lang=js"
export * from "./SetMedia.vue?vue&type=script&lang=js"
import style0 from "./SetMedia.vue?vue&type=style&index=0&id=3dab451c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab451c",
  null
  
)

export default component.exports